import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorPage from '@components/pages/ErrorPage';
import StartPage from './pages/StartPage/StartPage';
import ThankYouPage from './pages/ThankYouPage/ThankYouPage';
import KlarnaPagePPV from './pages/KlarnaPage/KlarnaPagePPV';
import TopBar from '@components/TopBar';
import Footer from '@components/Footer';

function StartPPVFlow() {
	return (
		<>
			<TopBar />
			<Routes>
				<Route path="/" element={<StartPage />} />
				<Route path="/payment" element={<KlarnaPagePPV />} />
				<Route path="/thank-you" element={<ThankYouPage />} />
				<Route path="*" element={<ErrorPage status={404} />} />
			</Routes>
			<Footer />
		</>
	);
}

export default StartPPVFlow;
